export const saveAuthCredentials = (credentials) => ({
  type: 'SAVE_AUTH_CREDENTIALS',
  credentials
});



// WEBPACK FOOTER //
// ./src/redux/auth/dispatch.js